<template>
    <section class="user-list">
        <div class="user-list__head">
            <div>
                <h6 class="mb-0">Agreement users</h6>
                <span class="text-muted small">{{ users.length }} installation{{ users.length === 1 ? '' : 's' }}</span>
            </div>
        </div>

        <div v-if="moveError" class="alert alert-danger py-2 mx-3 mt-3 mb-0">{{ moveError }}</div>

        <div v-if="!users.length" class="user-list__empty text-muted">
            No users on this agreement yet. Add one above.
        </div>

        <div v-else class="table-responsive">
            <table class="table table-hover align-middle mb-0 user-list__table">
                <thead>
                    <tr>
                        <th>User</th>
                        <th>App</th>
                        <th>Ship / device</th>
                        <th>Added</th>
                        <th>Max auto-approve</th>
                        <th>Move</th>
                    </tr>
                </thead>
                <tbody>
                    <agreement-user-row
                        v-for="user in users"
                        :key="user.userAgreementId"
                        :user="user"
                        :agreement-id="agreementId"
                        :agreements="agreements"
                        :edit-locked="!!editingUserId"
                        :disabled="editingUserId && editingUserId !== user.installationId"
                        :move-open="movingUserAgreementId === user.userAgreementId"
                        @edit-lock="setEditLock"
                        @move-open="setMoveOpen"
                        @save="savePriceForUser"
                        @move="moveUser"
                    />
                </tbody>
            </table>
        </div>
    </section>
</template>

<script>
import AgreementUserRow from './AgreementUserRow.vue';
import myAxios from '@/services/myAxios';

export default {
    components: { AgreementUserRow },
    props: {
        users: Array,
        agreementId: [String, Number],
        agreements: { type: Array, default: () => [] }
    },
    data() {
        return {
            editingUserId: null,
            movingUserAgreementId: null,
            moveError: null
        };
    },
    methods: {
        setEditLock(installationId) {
            this.editingUserId = installationId;
        },
        setMoveOpen(userAgreementId) {
            this.movingUserAgreementId = userAgreementId;
        },
        savePriceForUser(userAgreementId, newMaxPrice) {
            this.moveError = null;
            myAxios.post("/api/agreement/update-user-agreement", { userAgreementId, autoApproveByDistributorOrderMaxPrice: newMaxPrice })
                .then(() => {
                    this.$emit('fetch');
                })
                .catch(err => {
                    const data = err.response?.data;
                    this.moveError = typeof data === 'string' ? data : (data?.message ?? 'Failed to update');
                })
        },
        moveUser(userAgreementId, targetAgreementId, done) {
            this.moveError = null;
            myAxios.post("/api/agreement/move-user-inst", { userAgreementId, targetAgreementId })
                .then(() => {
                    this.movingUserAgreementId = null;
                    this.$emit('fetch');
                })
                .catch(err => {
                    const data = err.response?.data;
                    this.moveError = typeof data === 'string' ? data : (data?.message ?? 'Move failed');
                })
                .finally(() => {
                    if (typeof done === 'function') done();
                });
        }
    }
};
</script>

<style scoped>
.user-list {
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    overflow: hidden;
}

.user-list__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #e9ecef;
}

.user-list__empty {
    padding: 2rem 1.25rem;
    text-align: center;
}

.user-list__table thead th {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #6c757d;
    font-weight: 600;
    background: #f8f9fa;
    border-bottom-width: 1px;
    white-space: nowrap;
    padding: 0.65rem 1rem;
}

.user-list__table :deep(td) {
    padding: 0.75rem 1rem;
    vertical-align: middle;
}
</style>
